// extracted by mini-css-extract-plugin
module.exports = {"content":"_-_-pharmacy-src-user-userCard-userCard__content--luy5i"};